import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function PrivacyDataSharingIcon(props: IconProps) {
  return (
    <Icon width="72px" height="73px" viewBox="0 0 72 73" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="36" cy="36.8066" r="35.4" fill="white" stroke="white" strokeWidth="1.2" />
      <path d="M35.9999 41.8343L35.9999 32.6203" stroke="#00584F" strokeWidth="1.2" />
      <path d="M35.9999 29.0208L35.9999 19.8069" stroke="#00584F" strokeWidth="1.2" />
      <path d="M35.9999 54.8067L35.9999 45.5927" stroke="#00584F" strokeWidth="1.2" />
      <path d="M17.6662 37.0461L21.9223 41.3026L26.1783 37.0461" fill="white" />
      <path
        d="M17.6662 37.0461L21.9223 41.3026L26.1783 37.0461"
        stroke="#00584F"
        strokeWidth="1.2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M21.922 40.1262L21.922 23.2081C21.922 21.8166 20.794 20.6886 19.4026 20.6886L16 20.6886"
        stroke="#00584F"
        strokeWidth="1.2"
      />
      <path
        d="M25.2429 50.3091C25.2429 49.3816 24.8745 48.4922 24.2187 47.8364C23.5629 47.1806 22.6735 46.8122 21.7461 46.8122C20.8186 46.8122 19.9292 47.1806 19.2734 47.8364C18.6176 48.4922 18.2492 49.3816 18.2492 50.3091C18.2492 51.2365 18.6176 52.1259 19.2734 52.7817C19.9292 53.4375 20.8186 53.8059 21.7461 53.8059C22.6735 53.8059 23.5629 53.4375 24.2187 52.7817C24.8745 52.1259 25.2429 51.2365 25.2429 50.3091Z"
        fill="#40E398"
        stroke="#00584F"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M54.012 37.4485L49.7559 33.192L45.4999 37.4485" fill="white" />
      <path
        d="M54.012 37.4485L49.7559 33.192L45.4999 37.4485"
        stroke="#00584F"
        strokeWidth="1.2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M49.7562 34.3684L49.7562 51.2866C49.7562 52.678 50.8842 53.806 52.2757 53.806L55.6782 53.806"
        stroke="#00584F"
        strokeWidth="1.2"
      />
      <path
        d="M46.4353 24.1856C46.4353 25.113 46.8037 26.0024 47.4595 26.6582C48.1153 27.314 49.0047 27.6824 49.9322 27.6824C50.8596 27.6824 51.749 27.314 52.4048 26.6582C53.0606 26.0024 53.429 25.113 53.429 24.1856C53.429 23.2582 53.0606 22.3687 52.4048 21.7129C51.749 21.0571 50.8596 20.6887 49.9322 20.6887C49.0047 20.6887 48.1153 21.0571 47.4595 21.7129C46.8037 22.3687 46.4353 23.2581 46.4353 24.1856Z"
        fill="#40E398"
        stroke="#00584F"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}
